let dataLayer: any;
let appInsights: any;

class LoggingService {
  private static serviceInstance: LoggingService;

  public static get instance() {
    // eslint-disable-next-line no-return-assign
    return this.serviceInstance || (this.serviceInstance = new this());
  }

  public recordEvent(
    event: string = 'eventTracking',
    category: string,
    action: string,
    label: string
  ): void {
    const eventToSend = {
      action,
      category,
      event,
      label
    };
    try {
      (window as any).dataLayer.push(eventToSend);
    } catch {
      console.warn(
        'GTM data layer is not defined, event tracking is unavailable.',
        eventToSend
      );
    }
  }

  public recordPageView(urlToAppend: string, pageTitle: string): void {
    const eventToSend = {
      event: 'VirtualPageview',
      virtualPageTitle: pageTitle,
      virtualPageURL: `${window.location.pathname}${urlToAppend}`
    };
    try {
      dataLayer.push(eventToSend);
    } catch {
      console.warn(
        'GTM data layer is not defined, event tracking is unavailable.',
        eventToSend
      );
    }
  }

  // Track an application insights event.
  public trackAIEvent(eventName: string, properties: any, measurements: any) {
    try {
      appInsights.trackEvent(eventName, properties, measurements);
    } catch (e) {
      console.log(
        'Application insights is not defined, tracking unavailable.',
        { eventName, properties, measurements }
      );
    }
  }
}

// export a singleton instance in the global namespace
// eslint-disable-next-line import/prefer-default-export
export const loggingService = LoggingService.instance;
